<template>
    <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto pl-3 pr-3">
        <div class="clearfix row py-2 mb-2 border-bottom">
            <div class="col-sm-12 company-form-box-title text_color">Roles in Trustee Management</div>
        </div>
        <div class="clearfix row py-2 mt-4">
            <div class="col-sm-7">
                <div class="custom-search w-100">
                    <b-input-group class="mb-0">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-5 float-right text-right">
                <b-button id="show-btn" class="" @click="addNew()">+ Add Role</b-button>
            </div>
        </div>



        <div class="row justify-content-center py-2">
            <div class="col-sm-12">
                <b-modal id="bv-modal-role" size="lg" hide-footer :title="fdata.id > 0 ? 'Edit Role':'Add Role'">
                    <b-overlay :show="showoverlay" rounded="sm">
                          <b-form @submit.stop.prevent="onSubmit">
                              <div class="clearfix">
                                  <div class="px-3">
                                      <input type="hidden" v-model="fdata.id" name="id">

                                      <b-form-group  id="name-group" label="Name" class="required-field" label-for="name">
                                          <b-input-group>
                                              <b-form-input id="name" name="name" v-model="fdata.name" class="radius-8" v-validate="{ required: true, min: 3, max:40, regex: /^[A-Za-z .]+$/ }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                              <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                          </b-input-group>
                                      </b-form-group>

                                      <div class="text-center mt-5">
                                          <b-button class="px-5" v-if="fdata.id > 0" type="submit" variant="primary" >Update</b-button>
                                          <b-button class="px-5" v-else type="submit" variant="primary" >Save</b-button>
                                      </div>


                                  </div>
                              </div>
                          </b-form>
                    </b-overlay>
                </b-modal>
            </div>


            <div class="col-sm-12">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <div class="employee-table-wrapper" >
                        <table class="employee-list-table dataTable table-overflow table-sticky table data-table">
                            <thead>
                        <tr class="table-head">
                            <th class="">#</th>
                            <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
                            <th class="text-center">Action</th>
                        </tr>
                        </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="(role , n) in paginatedData" :key="role.id">
                                    <td class="col-md-1 align-middle list-columns text-center">{{ n+1 }}</td>
                                    <td class="col-md-5 align-middle list-columns leave-reason-wrapper">
                                        <template>{{role.name}}</template>
                                    </td>

                                    <td class="clearfix col-md-6 align-right">
                                        <div class="float-right mr-2 position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group class="mr-0">
                                                        <b-button class="mr-3 rounded edit-btn text-left" title="Edit Role" @click="editRole(role)">
                                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                        </b-button>
                                                        <b-button class="rounded delete-btn text-left" title="Delete Role" @click="deleteRole(role.id)">
                                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                    <div v-else class="px-3">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

                    </div>

                </b-overlay>
            </div>

        </div>

    </div>
</template>


<script>
export default{

    mounted() {
        this.permission = this.$acl['Role/details'];
    },
    props: ['ce_flg' , 'check_ce' , 'flg', 'pf'],
    data(){
        let sortOrders = {};
        let columns = [
            {label: 'Name', name: 'name' },
        ];
        columns.forEach((column) => {sortOrders[column.name] = -1;});
        return {

            roles:[],
            successmsg:null,
            errormsg:[],
            warningmsg:null,
            fdata: {status:null , id:null},
            saved_name : '',
            sortKey: 'name',
            columns:columns,
            sortOrders:sortOrders,
            pgurl:this.$api_url,
            file: null,
            showoverlay:false,
            showoverlay_list:false,
            go_back : false,
            go_next : false,
            finish : false,

            search:'',
            length: 20,
            temp_length:20,
            people:0,
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
            pagination: {currentPage: 1, pages:1},

            dangermsg:false,

            addtype : false,


            permission : 0,
        }
    },
    methods:{
        sortBy(key) {
            this.resetPagination();
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

            const order = this.sortOrders[key];

            this.paginatedData.sort((a, b) => {
                const result = String(a[key]).localeCompare(String(b[key]));
                return order == 1 ? result : -result;
            });
        },
        addNew() {
            this.fdata.id = null;
            this.fdata.name = null;
            this.resetForm();
            this.$bvModal.show('bv-modal-role');
        },
        getRoleData: function()
        {
            if(!this.checkNet()) return false;
            this.showoverlay_list = true;
            let currentObj = this;
            axios.get(this.$api_url+'/bot/role/list',{
              params:{
                pf:this.pf
              }
            }).then(response => {
                this.roles = response.data;
                this.people = this.roles.length;
                this.showoverlay_list = false;
            }).catch(error => this.serverError(error));
        },

        editRole:function(x)
        {
            this.addtype = false;
            this.fdata.id = x.id;
            this.fdata.name = x.name;
            this.$bvModal.show('bv-modal-role');
        },


        deleteRole:function(x) {
            if(!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this role.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
            })
                .then(value => {
                    if(value) {
                        this.resetForm();
                        this.showoverlay_list = true;

                        axios.post(this.$api_url+'/bot/role/delete/' + x + '?pf=' + this.pf).then(function(response){
                            this.successmsg = response.data.message;
                            this.$bvToast.toast(response.data.message, {
                                title: response.data.title,
                                variant: response.data.variant,
                                solid: true
                            });
                            this.showoverlay_list = false;

                            this.getRoleData();
                        }.bind(this)).catch(error => this.serverError(error));
                    }
                })
                .catch(err => {

                })
        },
        validateState(ref)
        {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm()
        {
            this.fdata = {name:null, status:null, id:null};
            this.file = null;
            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        onSubmit(e) {
            if(!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;
            this.$validator.validateAll().then(result => {
                if (!result) return;
                e.preventDefault();
                let currentObj = this;
                let formData = new FormData();

                if(this.fdata.id != null){
                    formData.append('id', this.fdata.id)
                }
                formData.append('name', this.fdata.name)

                axios.post(this.$api_url+'/bot/role/save?pf='+this.pf, formData)
                    .then( response => {

                        this.successmsg = 'Saved!';
                        this.$bvToast.toast(response.data.message, {
                            title: response.data.title,
                            variant: response.data.variant,
                            solid: true
                        });
                        this.getRoleData()
                        this.resetForm();
                        this.$bvModal.hide('bv-modal-role');

                    }).catch( error => {
                        currentObj.errormsg = error.response.data.errors;
                        this.serverError(error)
                    });
            });
        },

    },
    created: function(){
        this.getRoleData();
    },
    computed: {
        filteredData()
        {
            let filtered_list = this.roles;
            if (this.search)
            {
                filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
            }
            return filtered_list;
        },
        paginatedData()
        {

            //console.log(this.length);
            //console.log(this.filteredData);

            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
